<template>
  <div class="no-content">
    <div class="no-content-img">
    </div>
    <p class="no-content-text">哎呀，页面未找到！</p>
    <router-link :to="'/'" class="link-btn">返回首页</router-link>
  </div>
</template>
<script type="text/javascript ">
export default {
  data() {
    return {

    }
  }
}

</script>
<style lang="scss" rel="stylesheet/scss">
@import 'src/common/sass/mixin';

.no-content {
  position: absolute;
  left: 0;
  bottom: 0;
  text-align: center;
  width: 100%;
  height: 60%;
  .no-content-img {
    width: 1rem;
    height: 0.87rem;
    margin: 0 auto;
    @include bg-image('/static/images/icon_empty');
    background-size: 1rem 0.87rem;
    background-repeat: no-repeat;
    background-position: center;
  }

  .no-content-text {
    margin-top: 10px;
    text-align: center;
    color: #8a8a8a;
  }
  .link-btn {
    display: inline-block;
    padding: 10px 15px;
    border-radius: 4px;
    border: 1px solid #EC5555;
    color: #EC5555;
    margin-top: 20px;
    background-color: #fff;
  }
}

</style>



// WEBPACK FOOTER //
// 404.vue?433af020